import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import * as general from '../../libs/general';
import { formatOrderDateRangeLabel } from '../../libs/lib-date-range-filter';

// Dùng forwardRef để cha có thể gọi hàm từ con
const OrderAdminFilter = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const year = new Date().getFullYear();


  useEffect(() => {
    setShow(true);
  }, [data]);


  const handleModalShow = (e) => {

    var params = general.getSession('search_orders');
    window.initializeFilterValue(params);
    const dateFromInput = document.querySelector('input[name="dateFrom"]');
    if (dateFromInput) dateFromInput.value = params.dateFrom ?? '';
    const dateToInput = document.querySelector('input[name="dateTo"]');
    if (dateToInput) dateToInput.value = params.dateTo ?? '';
    updateDateRangeLabel(params.dateFrom, params.dateTo);
  };

  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSearchClick = () => {
    const dateFrom = document.querySelector('input[name="dateFrom"]')?.value ?? '';
    const dateTo = document.querySelector('input[name="dateTo"]')?.value ?? '';
    if (handleSearch) handleSearch({ page: 0, dateFrom, dateTo });
    handleModalClose();
  };

  const updateDateRangeLabel = (fromValue, toValue) => {
    const label = formatOrderDateRangeLabel(fromValue, toValue);
    if (window.addFilterValue) window.addFilterValue('dateRange', label);
  };

  const handleDateRangeChange = () => {
    const fromValue = document.querySelector('input[name="dateFrom"]')?.value ?? '';
    const toValue = document.querySelector('input[name="dateTo"]')?.value ?? '';
    updateDateRangeLabel(fromValue, toValue);
  };

  return (
    <Modal show={show} size="lg" onShow={() => handleModalShow()}>
      <div className="modal-dialog11 modal-lg11">
        <div className="modal-content normal-form">
          <div className="modal-header">
            <h5 className="modal-title">Tìm kiếm đơn hàng</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleModalClose}
              aria-label="Đóng"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Ngày</label>
                <div className="th select3">
                  <span className="filter-ib" data-form="form_filter" data-filter="dates" data-source-key="createdDate" data-source-url={API_URL_All + '/api/import-orders/searchDates'} data-default={year}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Line</label>
                <div className="th select3">
                  <span className="filter-ib" data-form="form_filter" data-filter="lines" data-source-key="list_lines"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className="col-md-6 mb-3">
                <label className="form-label">Từ ngày</label>
                <input type="date" className="form-control" name="dateFrom" form="form_filter" onChange={handleDateRangeChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Đến ngày</label>
                <input type="date" className="form-control" name="dateTo" form="form_filter" onChange={handleDateRangeChange} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3 th filter-area">
                <label className="form-label">Mã vận đơn TQ</label>
                <textarea placeholder="Nhập mã vận đơn TQ" className="form-control"></textarea>
                <div className=" select3 d-none">
                  <span className="filter-ib" data-form="form_filter" data-filter="chinaCodes" data-source-url={API_URL_All + '/api/import-orders/searchChinaCodes'}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3 th filter-area">
                <label className="form-label">Mã vận đơn VN</label>
                <textarea placeholder="Nhập mã vận đơn VN" className="form-control"></textarea>
                <div className="select3 d-none">
                  <span className="filter-ib" data-form="form_filter" data-filter="vietnamCodes" data-source-url={API_URL_All + '/api/import-orders/searchVietnamCodes'}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Tên sản phẩm</label>
                <div className="th select3">
                  <span className="filter-ib" data-form="form_filter" data-filter="productNames" data-source-url={API_URL_All + '/api/import-orders/searchProductNames'}><input type="text" placeholder="Nhập tên sản phẩm..." /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Mã khách hàng</label>
                <div className="th select3">
                  <span className="filter-ib filter-input" data-form="form_filter" data-filter="customers" data-source-url={API_URL_All + '/api/users/searchUserCodes'}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Lưu trình</label>
                <div className="th select3">
                  <span className="filter-ib filter-input" data-form="form_filter" data-filter="status" data-source-key="list_status"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Đối soát</label>
                <div className="th select3">                  
                  <span className="filter-ib filter-input" data-form="form_filter" data-filter="rateStatus" data-source-key="list_rateStatus"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Đối soát ĐT</label>
                <div className="th select3">
                  <span className="filter-ib filter-input" data-form="form_filter" data-filter="contactRateStatus" data-source-key="list_rateStatus"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-6 col-md-3 th filter-check">
                <span className="filter-ib" data-form="form_filter" data-filter="deletion"><input type="checkbox" /></span>
                <label className="form-check-label">Đã xóa</label>
              </div>
              <div className="col-6 col-md-3 th filter-check">
                <span className="filter-ib" data-form="form_filter" data-filter="draft"><input type="checkbox" /></span>
                <label className="form-check-label">Đơn nháp</label>
              </div>
              <div className="col-6 col-md-3 th filter-check">
                <span className="filter-ib" data-form="form_filter" data-filter="overdue"><input type="checkbox" /></span>
                <label className="form-check-label">Đơn chậm</label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-sm btn btn-primary" onClick={handleSearchClick}>Tìm kiếm</button>
          </div>
        </div>
      </div>

    </Modal>
  );
};

export default OrderAdminFilter;
